import React from 'react';
import { Link } from 'react-router-dom';
interface HeroProps {
  title: string;
  subtitle?: string;
  backgroundImage?: string;
  showCta?: boolean;
}
const Hero: React.FC<HeroProps> = ({
  title,
  subtitle,
  backgroundImage = '',
  showCta = false
}) => {
  return <div className={`w-full bg-[#1a2542] ${backgroundImage ? 'bg-cover bg-center' : ''}`} style={backgroundImage ? {
    backgroundImage: `url(${backgroundImage})`
  } : {}} data-id="element-52">
      <div className="container mx-auto px-4 py-20 md:py-32" data-id="element-53">
        <div className="max-w-3xl mx-auto text-center" data-id="element-54">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-serif text-white mb-6 leading-tight" data-id="element-55">
            {title}
          </h1>
          {subtitle && <p className="text-lg md:text-xl text-gray-200 mb-8 leading-relaxed" data-id="element-56">
              {subtitle}
            </p>}
          {showCta && <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-57">
              <Link to="/services" className="px-8 py-3 bg-[#c8a951] hover:bg-[#b39745] text-white rounded-md transition-colors duration-300 font-medium" data-id="element-58">
                Explore Our Services
              </Link>
              <Link to="/contact" className="px-8 py-3 bg-transparent hover:bg-white/10 text-white border border-white rounded-md transition-colors duration-300 font-medium" data-id="element-59">
                Contact Us
              </Link>
            </div>}
        </div>
      </div>
    </div>;
};
export default Hero;